
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34362',
  depVersions: {
  "documents-public-ui": "static-1.34362",
  "client-types": "static-1.459",
  "documents-lib": "static-1.34367",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2074",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5536",
  "hs-test-utils": "static-1.7958",
  "hub-http": "static-1.6164",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11403",
  "I18n": "static-7.1610",
  "jasmine-immutable": "static-1.2962",
  "jasmine-runner": "static-1.6413",
  "lodash": "static-1.3",
  "quartz": "static-1.6942",
  "react": "static-7.184",
  "react-dlb": "static-1.77",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16605",
  "reporting-data": "static-1.67256",
  "reporting-testing-lib": "static-1.9189",
  "reporting-visualizations": "static-1.59332",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4713",
  "webpack-env": "static-1.54",
  "atom": "static-1.5015",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2439",
  "classnames": "static-2.10",
  "cssUtils": "static-1.778",
  "customer-data-filters-ui": "static-1.39544",
  "customer-data-objects": "static-1.7604",
  "customer-data-property-utils": "static-1.8027",
  "data-fetching-client": "static-1.9617",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4467",
  "flux-actions": "static-1.329",
  "FormsCommonComponents": "static-1.85675",
  "FormUrlGenerator": "static-2.4663",
  "foundations-components": "static-1.7814",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11711",
  "icons": "static-2.643",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7102",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3791",
  "property-translator": "static-1.5346",
  "quartz-config": "static-1.720",
  "quartz-core": "static-1.6161",
  "quick-fetch": "static-1.3870",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-select-plus": "static-1.103",
  "react-utils": "static-2.5297",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8113",
  "reference-resolvers-lite": "static-1.8037",
  "report-customization-components": "static-1.12973",
  "reporting-enablement": "static-1.22687",
  "reporting-reports": "static-1.66934",
  "reporting-snowflake": "static-1.55874",
  "reporting-ui-components": "static-2.64527",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4589",
  "sales-content-partitioning": "static-1.8879",
  "SalesContentIndexUI": "static-3.9155",
  "sanitize": "static-1.4416",
  "sanitize-text": "static-1.8086",
  "self-service-api": "static-1.10189",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1688",
  "signup-constants": "static-1.18737",
  "signup-ui-lego-core": "static-1.20747",
  "signup-ui-url-generator": "static-2.7979",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.486",
  "superstore": "static-1.4710",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10932",
  "ui-addon-i18n": "static-1.11094",
  "ui-addon-react-router-dom": "static-1.9488",
  "ui-addon-upgrades": "static-9.17901",
  "ui-asset-management-lib": "static-1.10945",
  "ui-images": "static-2.1138",
  "UIComponents": "static-3.8350",
  "usage-tracker": "static-1.7280",
  "usage-tracker-container": "static-1.7270",
  "usage-tracker-core": "static-1.7130",
  "usage-tracker-public": "static-1.7091",
  "viral-links-lib": "static-1.6995",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3357",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3219",
  "quartz-webpack": "static-1.3166",
  "ai-components-ui-library": "static-1.8784",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4795",
  "foundations-theming": "static-1.4358",
  "quartz-auth": "static-1.617",
  "ui-business-units-lib": "static-1.8989",
  "usage-tracker-session-replay": "static-1.4966",
  "foundations-theming-base": "static-1.3343",
  "HeadJS": "static-2.740",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3069",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.37",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4268",
  "csstype": "static-1.50",
  "quartz-head": "static-1.607",
  "frontend-preferences-client": "static-1.7870",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3544",
  "persist-promise": "static-1.3651",
  "quartz-i18n": "static-1.617",
  "reporting-client-types": "static-1.2457",
  "foundations-components-legacy": "static-1.839",
  "hs-story-utils": "static-1.9372",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9826",
  "hubspotter-http": "static-1.4605",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7192",
  "crm-message-bus": "static-1.42828",
  "customer-data-filters-ui-msw-helpers": "static-1.21979",
  "customer-data-objects-ui-components": "static-1.12966",
  "customer-data-reference-ui-components": "static-1.13099",
  "customer-data-ui-utilities": "static-1.9769",
  "framework-builder-read-service-client": "static-1.3963",
  "framework-data-schema-quick-fetch": "static-1.6726",
  "framework-data-schema-resolvers": "static-1.6821",
  "inbound-db-properties-service-client": "static-1.3794",
  "multi-account-reference-resolvers": "static-1.922",
  "onboarding-tours": "static-1.16484",
  "reporting-datasets-permissions-lib": "static-1.13498",
  "ui-addon-teams": "static-1.21470",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68186",
  "customer-data-properties": "static-1.51343",
  "forms-ai-lib": "static-1.4223",
  "forms-utils-lib": "static-1.12466",
  "foundations-components-test-utils": "static-1.5297",
  "react-dnd-compat": "static-1.4563",
  "react-tinymce": "static-1.55074",
  "tinymce-config": "static-2.54200",
  "ui-gdpr-components": "static-1.10289",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4083",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "react-create-root-preference": "static-1.9",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1633",
  "ui-fonts": "static-1.665",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.826",
  "mobile-manifest-mixins": "static-1.514",
  "module-federation": "static-1.21",
  "quartz-routing": "static-1.372",
  "quartz-test": "static-1.617",
  "quartz-tracking": "static-1.321",
  "batch-promise": "static-1.1494",
  "external-options-client-types": "static-1.4112",
  "react-colorpicker": "static-2.10154",
  "copilot-toolkit": "static-1.10960",
  "data-quality-ui-library": "static-1.12726",
  "html-to-image": "static-1.52",
  "onboarding-scopes": "static-1.6406",
  "reporting-action-components": "static-1.41137",
  "reporting-filters": "static-1.161",
  "reporting-insights-lib": "static-1.1559",
  "reporting-plugins": "static-1.10195",
  "ui-addon-draggable-compat": "static-2.4198",
  "ui-addon-opt": "static-4.8319",
  "zustand": "static-1.72",
  "growth-payments-core": "static-1.25195",
  "hubspot-apollo-client": "static-1.4820",
  "chirp-fetch": "static-1.1828",
  "sales-templates-service-types-lib": "static-1.4121",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5777",
  "salesImages": "static-1.524",
  "ts-schema": "static-1.4031",
  "nested-table": "static-1.168",
  "timezone-utils": "static-2.5187",
  "bender-build-tools": "static-1.3093",
  "chatspot-core": "static-1.21004",
  "bend-plugin-foundations-theming": "static-1.2841",
  "stylex": "static-1.31",
  "hubspotter-http-shared-msw-handlers": "static-1.9824",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3750",
  "crm-pipelines-api-client-types": "static-1.4096",
  "multi-currency-client-types": "static-1.3645",
  "getting-started-shared-tasks": "static-1.18335",
  "growth-data-modal": "static-1.5333",
  "growth-onboarding-confetti": "static-1.3011",
  "growth-onboarding-next-action-utils": "static-1.1743",
  "navigation-components": "static-1.17821",
  "onboarding-tours-client": "static-1.4698",
  "onboarding-tours-utils": "static-1.550",
  "ui-shepherd-react": "static-3.10092",
  "ui-shepherd-tracker": "static-1.7473",
  "ui-universal-auth": "static-1.8901",
  "user-context": "static-1.5044",
  "cms-field-types": "static-1.4754",
  "content-icons-ui": "static-1.2211",
  "integrations-lib": "static-1.15927",
  "calling-global-api": "static-1.64300",
  "calling-internal-common": "static-1.31244",
  "calling-lifecycle-internal": "static-1.65682",
  "calling-lifecycle-messages": "static-1.57976",
  "commerce-products-lib": "static-1.9308",
  "crm-links": "static-1.6222",
  "customer-data-properties-shared-msw-handlers": "static-1.9153",
  "file-manager-components": "static-1.23449",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.85",
  "inbounddb-objects-service-types": "static-1.4177",
  "meetings-icalendar-utils-lib": "static-1.574",
  "object-builder-ui-client": "static-1.48539",
  "pipeline-validation-client-types": "static-1.3919",
  "property-value-citations": "static-1.1957",
  "pulse": "static-1.497",
  "smart-property-lib": "static-1.6650",
  "tiered-pricing": "static-1.1082",
  "ui-addon-iframeable": "static-1.8996",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19726",
  "tinymce-themes": "static-1.56170",
  "data-token-picker": "static-1.16298",
  "hub-http-contrib": "static-1.2983",
  "interframe": "static-3.4704",
  "tinymce-data": "static-1.40285",
  "tinymce-plugins": "static-1.57314",
  "ui-addon-sales-email": "static-1.5153",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "magpie-lib": "static-1.5523",
  "magpie-types": "static-1.4983",
  "simple-logging-lib": "static-1.2992",
  "content-assistance-lib": "static-1.7660",
  "dashboard-lib": "static-1.81290",
  "ExportDialog": "static-6.10336",
  "hubspot-prosemirror": "static-1.18063",
  "hubspot-prosemirror-plugins": "static-1.18055",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8640",
  "campaign-roi-lib": "static-1.8895",
  "feedback-loader": "static-1.29190",
  "apollo-link-hub-http": "static-2.4592",
  "hubspot-apollo-cache": "static-1.279",
  "purchase-motions-api": "static-1.5780",
  "trials-service-types": "static-1.3846",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.115",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.1858",
  "growth-onboarding-next-action-components": "static-1.1771",
  "user-context-client": "static-1.4553",
  "idb-keyval": "static-1.42",
  "nest": "static-1.167",
  "reactive-lib": "static-1.664",
  "unified-auth-core-lib": "static-1.696",
  "getting-started-shared-tasks-store": "static-1.17453",
  "integrations-error-boundary-lib": "static-1.13342",
  "integrations-tracking-lib": "static-1.5540",
  "native-integrations-shared-strings": "static-1.7727",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10315",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.415",
  "calling-error-reporting": "static-1.31250",
  "shared-worker-versioning": "static-1.10980",
  "calling-usage-tracker": "static-1.6485",
  "voice-sms-access-library": "static-1.748",
  "customer-data-tracking": "static-1.6829",
  "commerce-permissions": "static-1.708",
  "products-iframe-lib": "static-1.7756",
  "products-ui-components-shared-msw-handlers": "static-1.10208",
  "location-customization-utils-lib": "static-1.9067",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4097",
  "video-components-external": "static-1.11080",
  "video-data-lib": "static-1.34738",
  "directed-graph": "static-1.879",
  "event-emitter": "static-1.892",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.100",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9909",
  "fsm": "static-1.3676",
  "policy-lib": "static-1.6715",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9972",
  "navigation-messaging": "static-1.7148",
  "FileManagerLib": "static-1.39089",
  "NamespacedHubStyle": "static-2.9016",
  "FileManagerCore": "static-1.38948",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12326",
  "layout-dnd-utils": "static-1.11301",
  "react-codemirror": "static-1.10567",
  "ui-addon-emoji-picker": "static-1.9831",
  "ui-brand-identity-lib": "static-1.14974",
  "ui-addon-video-player": "static-1.8641",
  "ui-coaching-tips": "static-1.28379",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8479",
  "payment-link-components": "static-1.23364",
  "EmailSignatureEditor": "static-1.24243",
  "InboxConnectUtils": "static-4.14635",
  "universal-page-editor-lib": "static-1.2954",
  "google-sheets-integration-lib": "static-1.63",
  "microsoft-drive-integration-lib": "static-1.170",
  "calling-orchestration-schema": "static-1.35525",
  "sales-views-client-types": "static-1.4207",
  "crm-record-cards-service-types": "static-1.3564",
  "content-media-composition-data-lib": "static-1.12051",
  "content-media-compositions": "static-2.16058",
  "media-bridge-lib": "static-1.18822",
  "trellis-story-utils": "static-1.4459",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5825",
  "FileManagerImages": "static-1.36600",
  "video-components": "static-1.13083",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4475",
  "video-embed": "static-1.35572",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68261",
  "layout-data-lib": "static-1.9626",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6527",
  "commerce-tours-lib": "static-1.5984",
  "growth-onboarding-reliability": "static-1.5025",
  "sales-checkout-service-client": "static-1.3582",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21565",
  "sales-email-signature-service-client": "static-1.3785",
  "social-insights-client-types": "static-1.21916",
  "outpost": "static-1.4133",
  "advanced-menus-core": "static-1.15034",
  "advanced-menus-lib": "static-1.11988",
  "ui-memberships-settings-lib": "static-1.33885",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15033",
  "simple-menus-lib": "static-1.16550"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34362",
  "client-types": "/client-types/static-1.459",
  "documents-lib": "/documents-lib/static-1.34367",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2074",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5536",
  "hs-test-utils": "/hs-test-utils/static-1.7958",
  "hub-http": "/hub-http/static-1.6164",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11403",
  "I18n": "/I18n/static-7.1610",
  "jasmine-immutable": "/jasmine-immutable/static-1.2962",
  "jasmine-runner": "/jasmine-runner/static-1.6413",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6942",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16605",
  "reporting-data": "/reporting-data/static-1.67256",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9189",
  "reporting-visualizations": "/reporting-visualizations/static-1.59332",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4713",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5015",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2439",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.778",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39544",
  "customer-data-objects": "/customer-data-objects/static-1.7604",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8027",
  "data-fetching-client": "/data-fetching-client/static-1.9617",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4467",
  "flux-actions": "/flux-actions/static-1.329",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85675",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4663",
  "foundations-components": "/foundations-components/static-1.7814",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11711",
  "icons": "/icons/static-2.643",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7102",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3791",
  "property-translator": "/property-translator/static-1.5346",
  "quartz-config": "/quartz-config/static-1.720",
  "quartz-core": "/quartz-core/static-1.6161",
  "quick-fetch": "/quick-fetch/static-1.3870",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-select-plus": "/react-select-plus/static-1.103",
  "react-utils": "/react-utils/static-2.5297",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8113",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8037",
  "report-customization-components": "/report-customization-components/static-1.12973",
  "reporting-enablement": "/reporting-enablement/static-1.22687",
  "reporting-reports": "/reporting-reports/static-1.66934",
  "reporting-snowflake": "/reporting-snowflake/static-1.55874",
  "reporting-ui-components": "/reporting-ui-components/static-2.64527",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4589",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8879",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9155",
  "sanitize": "/sanitize/static-1.4416",
  "sanitize-text": "/sanitize-text/static-1.8086",
  "self-service-api": "/self-service-api/static-1.10189",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1688",
  "signup-constants": "/signup-constants/static-1.18737",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20747",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7979",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "superstore": "/superstore/static-1.4710",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10932",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11094",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9488",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17901",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10945",
  "ui-images": "/ui-images/static-2.1138",
  "UIComponents": "/UIComponents/static-3.8350",
  "usage-tracker": "/usage-tracker/static-1.7280",
  "usage-tracker-container": "/usage-tracker-container/static-1.7270",
  "usage-tracker-core": "/usage-tracker-core/static-1.7130",
  "usage-tracker-public": "/usage-tracker-public/static-1.7091",
  "viral-links-lib": "/viral-links-lib/static-1.6995",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3357",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3219",
  "quartz-webpack": "/quartz-webpack/static-1.3166",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8784",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4795",
  "foundations-theming": "/foundations-theming/static-1.4358",
  "quartz-auth": "/quartz-auth/static-1.617",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8989",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4966",
  "foundations-theming-base": "/foundations-theming-base/static-1.3343",
  "HeadJS": "/HeadJS/static-2.740",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3069",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.37",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4268",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.607",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7870",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3544",
  "persist-promise": "/persist-promise/static-1.3651",
  "quartz-i18n": "/quartz-i18n/static-1.617",
  "reporting-client-types": "/reporting-client-types/static-1.2457",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.839",
  "hs-story-utils": "/hs-story-utils/static-1.9372",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9826",
  "hubspotter-http": "/hubspotter-http/static-1.4605",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7192",
  "crm-message-bus": "/crm-message-bus/static-1.42828",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21979",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12966",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13099",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9769",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3963",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6726",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6821",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3794",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.922",
  "onboarding-tours": "/onboarding-tours/static-1.16484",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13498",
  "ui-addon-teams": "/ui-addon-teams/static-1.21470",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68186",
  "customer-data-properties": "/customer-data-properties/static-1.51343",
  "forms-ai-lib": "/forms-ai-lib/static-1.4223",
  "forms-utils-lib": "/forms-utils-lib/static-1.12466",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5297",
  "react-dnd-compat": "/react-dnd-compat/static-1.4563",
  "react-tinymce": "/react-tinymce/static-1.55074",
  "tinymce-config": "/tinymce-config/static-2.54200",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10289",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4083",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "react-create-root-preference": "/react-create-root-preference/static-1.9",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1633",
  "ui-fonts": "/ui-fonts/static-1.665",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.826",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
  "module-federation": "/module-federation/static-1.21",
  "quartz-routing": "/quartz-routing/static-1.372",
  "quartz-test": "/quartz-test/static-1.617",
  "quartz-tracking": "/quartz-tracking/static-1.321",
  "batch-promise": "/batch-promise/static-1.1494",
  "external-options-client-types": "/external-options-client-types/static-1.4112",
  "react-colorpicker": "/react-colorpicker/static-2.10154",
  "copilot-toolkit": "/copilot-toolkit/static-1.10960",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12726",
  "html-to-image": "/html-to-image/static-1.52",
  "onboarding-scopes": "/onboarding-scopes/static-1.6406",
  "reporting-action-components": "/reporting-action-components/static-1.41137",
  "reporting-filters": "/reporting-filters/static-1.161",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1559",
  "reporting-plugins": "/reporting-plugins/static-1.10195",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4198",
  "ui-addon-opt": "/ui-addon-opt/static-4.8319",
  "zustand": "/zustand/static-1.72",
  "growth-payments-core": "/growth-payments-core/static-1.25195",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4820",
  "chirp-fetch": "/chirp-fetch/static-1.1828",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4121",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5777",
  "salesImages": "/salesImages/static-1.524",
  "ts-schema": "/ts-schema/static-1.4031",
  "nested-table": "/nested-table/static-1.168",
  "timezone-utils": "/timezone-utils/static-2.5187",
  "bender-build-tools": "/bender-build-tools/static-1.3093",
  "chatspot-core": "/chatspot-core/static-1.21004",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2841",
  "stylex": "/stylex/static-1.31",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9824",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3750",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4096",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3645",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18335",
  "growth-data-modal": "/growth-data-modal/static-1.5333",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3011",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1743",
  "navigation-components": "/navigation-components/static-1.17821",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4698",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.550",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10092",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7473",
  "ui-universal-auth": "/ui-universal-auth/static-1.8901",
  "user-context": "/user-context/static-1.5044",
  "cms-field-types": "/cms-field-types/static-1.4754",
  "content-icons-ui": "/content-icons-ui/static-1.2211",
  "integrations-lib": "/integrations-lib/static-1.15927",
  "calling-global-api": "/calling-global-api/static-1.64300",
  "calling-internal-common": "/calling-internal-common/static-1.31244",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65682",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57976",
  "commerce-products-lib": "/commerce-products-lib/static-1.9308",
  "crm-links": "/crm-links/static-1.6222",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9153",
  "file-manager-components": "/file-manager-components/static-1.23449",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.85",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4177",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.574",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48539",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3919",
  "property-value-citations": "/property-value-citations/static-1.1957",
  "pulse": "/pulse/static-1.497",
  "smart-property-lib": "/smart-property-lib/static-1.6650",
  "tiered-pricing": "/tiered-pricing/static-1.1082",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8996",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19726",
  "tinymce-themes": "/tinymce-themes/static-1.56170",
  "data-token-picker": "/data-token-picker/static-1.16298",
  "hub-http-contrib": "/hub-http-contrib/static-1.2983",
  "interframe": "/interframe/static-3.4704",
  "tinymce-data": "/tinymce-data/static-1.40285",
  "tinymce-plugins": "/tinymce-plugins/static-1.57314",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5153",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "magpie-lib": "/magpie-lib/static-1.5523",
  "magpie-types": "/magpie-types/static-1.4983",
  "simple-logging-lib": "/simple-logging-lib/static-1.2992",
  "content-assistance-lib": "/content-assistance-lib/static-1.7660",
  "dashboard-lib": "/dashboard-lib/static-1.81290",
  "ExportDialog": "/ExportDialog/static-6.10336",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18063",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18055",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8640",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8895",
  "feedback-loader": "/feedback-loader/static-1.29190",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4592",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.279",
  "purchase-motions-api": "/purchase-motions-api/static-1.5780",
  "trials-service-types": "/trials-service-types/static-1.3846",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.115",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1858",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1771",
  "user-context-client": "/user-context-client/static-1.4553",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.167",
  "reactive-lib": "/reactive-lib/static-1.664",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.696",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17453",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13342",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5540",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7727",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10315",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.415",
  "calling-error-reporting": "/calling-error-reporting/static-1.31250",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10980",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6485",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.748",
  "customer-data-tracking": "/customer-data-tracking/static-1.6829",
  "commerce-permissions": "/commerce-permissions/static-1.708",
  "products-iframe-lib": "/products-iframe-lib/static-1.7756",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10208",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9067",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4097",
  "video-components-external": "/video-components-external/static-1.11080",
  "video-data-lib": "/video-data-lib/static-1.34738",
  "directed-graph": "/directed-graph/static-1.879",
  "event-emitter": "/event-emitter/static-1.892",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.100",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9909",
  "fsm": "/fsm/static-1.3676",
  "policy-lib": "/policy-lib/static-1.6715",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9972",
  "navigation-messaging": "/navigation-messaging/static-1.7148",
  "FileManagerLib": "/FileManagerLib/static-1.39089",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9016",
  "FileManagerCore": "/FileManagerCore/static-1.38948",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12326",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11301",
  "react-codemirror": "/react-codemirror/static-1.10567",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9831",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14974",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8641",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28379",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "payment-link-components": "/payment-link-components/static-1.23364",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24243",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14635",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2954",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.63",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.170",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35525",
  "sales-views-client-types": "/sales-views-client-types/static-1.4207",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3564",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12051",
  "content-media-compositions": "/content-media-compositions/static-2.16058",
  "media-bridge-lib": "/media-bridge-lib/static-1.18822",
  "trellis-story-utils": "/trellis-story-utils/static-1.4459",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5825",
  "FileManagerImages": "/FileManagerImages/static-1.36600",
  "video-components": "/video-components/static-1.13083",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4475",
  "video-embed": "/video-embed/static-1.35572",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68261",
  "layout-data-lib": "/layout-data-lib/static-1.9626",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6527",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5984",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5025",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3582",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21565",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3785",
  "social-insights-client-types": "/social-insights-client-types/static-1.21916",
  "outpost": "/outpost/static-1.4133",
  "advanced-menus-core": "/advanced-menus-core/static-1.15034",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11988",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33885",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15033",
  "simple-menus-lib": "/simple-menus-lib/static-1.16550"
}
};
